import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { RefObject, useRef } from "react";
import {
  contentWrapperSx,
  descriptionSx,
  lineAndBubbleWrapperSx,
  sectionContainerSx,
} from "./AboutCledarSection.sx";
import { ConnectorLine } from "./ConnectorLine";
import { sectionTitle, sectionDescription } from "./AboutCledarSection.config";
import { useAboutCledarAnimation } from "./useAboutCledarAnimation";

export interface AboutCledarSectionProps {
  scrollTriggerRef?: RefObject<HTMLDivElement | null>;
  sectionAnimRef?: RefObject<HTMLDivElement | null>;
}

export const AboutCledarSection = ({
  scrollTriggerRef,
  sectionAnimRef,
}: AboutCledarSectionProps) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const mobilePathRef = useRef<SVGPathElement>(null);
  const desktopPathRef = useRef<SVGPathElement>(null);

  const { initAnimation } = useAboutCledarAnimation({
    sectionRef,
    mobilePathRef,
    desktopPathRef,
    scrollTriggerRef,
  });

  return (
    <Box
      component="section"
      ref={(el: HTMLDivElement | null) => {
        (sectionRef as React.MutableRefObject<HTMLDivElement | null>).current =
          el;
        if (sectionAnimRef) {
          (
            sectionAnimRef as React.MutableRefObject<HTMLDivElement | null>
          ).current = el;
        }
      }}
      sx={sectionContainerSx}
    >
      <Box sx={contentWrapperSx}>
        <Typography variant="h2" component="h2">
          {sectionTitle}
        </Typography>

        <Box sx={lineAndBubbleWrapperSx}>
          <ConnectorLine
            mobilePathRef={mobilePathRef}
            desktopPathRef={desktopPathRef}
            onPathsReady={initAnimation}
          />

          <Typography sx={descriptionSx}>{sectionDescription}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutCledarSection;
